(function() {
  'use strict';

  const TOTAL_STEPS = 6;
  let currentStep = 0;
  let selectedTags = [];
  let quizAnswers = {};

  // DOM refs
  const stepsContainer = document.getElementById('quiz-steps');
  const progressBar = document.getElementById('quiz-progress');
  const resultsEl = document.getElementById('quiz-results');
  const resultsGrid = document.getElementById('results-grid');
  const resultsSub = document.getElementById('results-subtitle');
  const restartBtn = document.getElementById('quiz-restart');

  if (!stepsContainer) return;

  // Tab switching
  document.querySelectorAll('.plant-quiz__tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.plant-quiz__tab').forEach(t => t.classList.remove('plant-quiz__tab--active'));
      document.querySelectorAll('.plant-quiz__panel').forEach(p => p.classList.remove('plant-quiz__panel--active'));
      tab.classList.add('plant-quiz__tab--active');
      document.getElementById(tab.dataset.tab === 'quiz' ? 'quiz-panel' : 'ai-panel').classList.add('plant-quiz__panel--active');
    });
  });

  // Quiz option clicks
  stepsContainer.addEventListener('click', (e) => {
    const option = e.target.closest('.plant-quiz__option');
    if (!option) return;

    const step = parseInt(option.dataset.step);
    const tag = option.dataset.tag;

    // Mark selected
    const stepEl = option.closest('.plant-quiz__step');
    stepEl.querySelectorAll('.plant-quiz__option').forEach(o => o.classList.remove('plant-quiz__option--selected'));
    option.classList.add('plant-quiz__option--selected');

    // Store answer
    quizAnswers[step] = { tag: tag, label: option.querySelector('.plant-quiz__option-label').textContent };

    // Add tag (skip if "skip")
    selectedTags = Object.values(quizAnswers).filter(a => a.tag !== 'skip').map(a => a.tag);

    setTimeout(() => {
      if (step < TOTAL_STEPS - 1) {
        goToStep(step + 1);
      } else {
        showResults();
      }
    }, 300);
  });

  function goToStep(step) {
    currentStep = step;
    document.querySelectorAll('.plant-quiz__step').forEach(s => s.classList.remove('plant-quiz__step--active'));
    const nextStep = stepsContainer.querySelector(`[data-step="${step}"]`);
    if (nextStep) nextStep.classList.add('plant-quiz__step--active');
    progressBar.style.width = ((step + 1) / TOTAL_STEPS * 100) + '%';
  }

  async function showResults() {
    stepsContainer.style.display = 'none';
    document.querySelector('.plant-quiz__progress').style.display = 'none';
    resultsEl.style.display = 'block';
    progressBar.style.width = '100%';

    resultsGrid.innerHTML = '<div style="text-align:center;padding:24px;color:rgba(255,255,255,0.5)">Loading recommendations...</div>';

    try {
      const products = await fetchMatchingProducts(selectedTags);

      if (products.length === 0) {
        resultsGrid.innerHTML = '<div class="plant-quiz__no-results"><h4>No exact matches found</h4><p>Try browsing our full plant collection for similar options.</p></div>';
        resultsSub.textContent = '';
      } else {
        resultsSub.textContent = `We found ${products.length} plant${products.length > 1 ? 's' : ''} matching your preferences`;
        resultsGrid.innerHTML = products.slice(0, 6).map(p => renderProductCard(p)).join('');
      }

      // Track quiz completion
      trackQuizEvent('quiz_complete', {
        answers: quizAnswers,
        tags: selectedTags,
        resultCount: products.length,
        resultTitles: products.slice(0, 6).map(p => p.title)
      });
    } catch (err) {
      resultsGrid.innerHTML = '<div class="plant-quiz__no-results"><h4>Something went wrong</h4><p>Please try again or browse our plant collection.</p></div>';
    }
  }

  async function fetchMatchingProducts(tags) {
    // Fetch all plant products from the storefront
    let allProducts = [];
    let page = 1;
    while (true) {
      const resp = await fetch(`/collections/all/products.json?limit=250&page=${page}`);
      const data = await resp.json();
      if (!data.products || data.products.length === 0) break;
      allProducts = allProducts.concat(data.products);
      page++;
      if (data.products.length < 250) break;
    }

    // Filter for plants that have quiz tags
    const plantProducts = allProducts.filter(p =>
      p.tags && p.tags.some(t => t.startsWith('difficulty:'))
    );

    // Score products by how many tags match
    const scored = plantProducts.map(p => {
      const productTags = p.tags.map(t => t.trim().toLowerCase());
      let score = 0;
      let matches = 0;

      tags.forEach(tag => {
        const tagLower = tag.toLowerCase();
        // Extract category (e.g., "difficulty" from "difficulty:beginner")
        const category = tagLower.split(':')[0];

        // Check if any product tag matches this category
        const categoryTags = productTags.filter(pt => pt.startsWith(category + ':'));

        if (categoryTags.includes(tagLower)) {
          score += 10; // Exact match
          matches++;
        } else if (categoryTags.length > 0) {
          score -= 2; // Has category but different value
        }
        // If product doesn't have that category tag at all, neutral (score += 0)
      });

      return { product: p, score, matches };
    });

    // Sort by score, then by number of matches
    scored.sort((a, b) => b.score - a.score || b.matches - a.matches);

    // Return top results with positive scores, or relax if none found
    let results = scored.filter(s => s.score > 0).map(s => s.product);

    if (results.length === 0) {
      // Relax: return products matching at least 2 tags
      results = scored.filter(s => s.matches >= 2).map(s => s.product);
    }

    if (results.length === 0) {
      // Further relax: return top scored products
      results = scored.filter(s => s.matches >= 1).slice(0, 6).map(s => s.product);
    }

    return results;
  }

  function renderProductCard(product) {
    const img = product.images && product.images[0]
      ? product.images[0].src
      : 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200" fill="%231a3522"%3E%3Crect width="200" height="200"/%3E%3Ctext x="50%25" y="50%25" fill="%23ffffff33" text-anchor="middle" dy=".3em" font-size="40"%3E🌿%3C/text%3E%3C/svg%3E';
    const price = product.variants && product.variants[0]
      ? '$' + parseFloat(product.variants[0].price).toFixed(2)
      : '';
    const url = '/products/' + product.handle;

    // Show relevant quiz tags as badges
    const quizTags = (product.tags || [])
      .filter(t => t.includes(':') && !t.startsWith('use:') && !t.startsWith('tank:'))
      .slice(0, 4)
      .map(t => {
        const val = t.split(':')[1];
        return `<span class="plant-quiz__product-tag">${val}</span>`;
      }).join('');

    return `
      <a href="${url}" class="plant-quiz__product-card" data-product-title="${product.title}">
        <img class="plant-quiz__product-img" src="${img.replace(/\.jpg|\.png/, '_300x300$&')}" alt="${product.title}" loading="lazy" width="300" height="300">
        <div class="plant-quiz__product-info">
          <p class="plant-quiz__product-name">${product.title}</p>
          <span class="plant-quiz__product-price">${price}</span>
          <div class="plant-quiz__product-tags">${quizTags}</div>
        </div>
      </a>
    `;
  }

  // Restart quiz
  if (restartBtn) {
    restartBtn.addEventListener('click', () => {
      currentStep = 0;
      selectedTags = [];
      quizAnswers = {};
      resultsEl.style.display = 'none';
      stepsContainer.style.display = '';
      document.querySelector('.plant-quiz__progress').style.display = '';
      progressBar.style.width = '0%';
      document.querySelectorAll('.plant-quiz__step').forEach(s => s.classList.remove('plant-quiz__step--active'));
      document.querySelector('[data-step="0"]').classList.add('plant-quiz__step--active');
      document.querySelectorAll('.plant-quiz__option').forEach(o => o.classList.remove('plant-quiz__option--selected'));
    });
  }

  // ===== AI TAB =====
  const aiInput = document.getElementById('ai-input');
  const aiSubmit = document.getElementById('ai-submit');
  const aiResults = document.getElementById('ai-results');
  const aiResponse = document.getElementById('ai-response');
  const aiResultsGrid = document.getElementById('ai-results-grid');
  const aiSubmitText = document.getElementById('ai-submit-text');
  const aiSubmitLoading = document.getElementById('ai-submit-loading');

  if (aiSubmit) {
    aiSubmit.addEventListener('click', handleAIQuery);
    if (aiInput) {
      aiInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          handleAIQuery();
        }
      });
    }
  }

  async function handleAIQuery() {
    const question = aiInput.value.trim();
    if (!question) return;

    aiSubmitText.style.display = 'none';
    aiSubmitLoading.style.display = 'inline-flex';
    aiSubmit.disabled = true;

    try {
      // Get AI endpoint from section settings (embedded in page)
      const section = document.getElementById('plant-quiz');
      const endpoint = section?.dataset?.aiEndpoint;

      if (endpoint) {
        // Use Claude API via Cloudflare Worker
        const resp = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ question })
        });
        const data = await resp.json();

        aiResponse.innerHTML = data.response || 'Here are some recommendations based on your description:';
        if (data.products && data.products.length > 0) {
          aiResultsGrid.innerHTML = data.products.map(p => renderProductCard(p)).join('');
        }
      } else {
        // Fallback: smart tag matching from the question text
        const inferredTags = inferTagsFromText(question);
        const products = await fetchMatchingProducts(inferredTags);

        aiResponse.innerHTML = `Based on your description, I found <strong>${products.length} matching plants</strong>. Here are the top recommendations:`;
        aiResultsGrid.innerHTML = products.slice(0, 6).map(p => renderProductCard(p)).join('');
      }

      aiResults.style.display = 'block';

      // Track
      trackQuizEvent('ai_query', {
        question: question,
        resultCount: aiResultsGrid.children.length
      });
    } catch (err) {
      aiResponse.innerHTML = 'Sorry, something went wrong. Please try again.';
      aiResults.style.display = 'block';
    }

    aiSubmitText.style.display = '';
    aiSubmitLoading.style.display = 'none';
    aiSubmit.disabled = false;
  }

  function inferTagsFromText(text) {
    const t = text.toLowerCase();
    const tags = [];

    // Difficulty
    if (t.includes('beginner') || t.includes('easy') || t.includes('low tech') || t.includes('low-tech') || t.includes('simple'))
      tags.push('difficulty:beginner');
    else if (t.includes('advanced') || t.includes('expert') || t.includes('challenge'))
      tags.push('difficulty:advanced');
    else if (t.includes('intermediate') || t.includes('moderate'))
      tags.push('difficulty:intermediate');

    // Light
    if (t.includes('low light') || t.includes('low-light') || t.includes('basic light'))
      tags.push('light:low');
    else if (t.includes('high light') || t.includes('high-light') || t.includes('strong light'))
      tags.push('light:high');
    else if (t.includes('medium light') || t.includes('moderate light'))
      tags.push('light:medium');

    // CO2
    if (t.includes('no co2') || t.includes('without co2') || t.includes('low tech') || t.includes('low-tech'))
      tags.push('co2:not-required');
    else if (t.includes('co2') || t.includes('high tech') || t.includes('high-tech'))
      tags.push('co2:required');

    // Placement
    if (t.includes('foreground') || t.includes('front'))
      tags.push('placement:foreground');
    if (t.includes('background') || t.includes('back of'))
      tags.push('placement:background');
    if (t.includes('carpet') || t.includes('ground cover'))
      tags.push('placement:carpeting');
    if (t.includes('midground') || t.includes('middle'))
      tags.push('placement:midground');

    // Colour
    if (t.includes('red')) tags.push('colour:red');
    if (t.includes('green')) tags.push('colour:green');
    if (t.includes('brown')) tags.push('colour:brown');

    // Tank size
    if (t.includes('nano') || t.match(/\b(5|10|15)\s*l/))
      tags.push('tank:nano');
    else if (t.match(/\b(20|30|40|50|60)\s*l/) || t.includes('small'))
      tags.push('tank:small');
    else if (t.match(/\b(80|100|120|150|200)\s*l/) || t.includes('medium'))
      tags.push('tank:medium');
    else if (t.match(/\b(250|300|400|500)\s*l/) || t.includes('large'))
      tags.push('tank:large');

    return tags;
  }

  // ===== ANALYTICS =====
  function trackQuizEvent(eventType, data) {
    try {
      const section = document.getElementById('plant-quiz');
      const endpoint = section?.dataset?.airtableEndpoint;
      if (!endpoint) return;

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event: eventType,
          timestamp: new Date().toISOString(),
          ...data
        })
      }).catch(() => {});
    } catch (e) {}
  }

  // Track product card clicks
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.plant-quiz__product-card');
    if (card) {
      trackQuizEvent('product_click', {
        productTitle: card.dataset.productTitle,
        source: card.closest('#ai-results-grid') ? 'ai' : 'quiz'
      });
    }
  });

})();
